// extracted by mini-css-extract-plugin
module.exports = {"LoadingCircle":"LoadingCircle_LoadingCircle__os8LM","spin":"LoadingCircle_spin__5J0px"};